/**
 * Created by lidonghua on 2018/4/4.
 */



export const utils = {
    pageLock: function () {
        document.addEventListener("touchmove", utils.pageLockHandler, false)
    },
    pageUnlock: function () {
        document.removeEventListener("touchmove", utils.pageLockHandler, false)
    },
    pageLockHandler: function (e) {
        e.preventDefault();
    }
}

/*
 * 获取随机字符串
 * getRandomStr(8)
 * */
export function getRandomStr(len) {
    var result = [];
    var str = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghigklmnopqrstuvwxyz0123456789-_';
    for (var i = 0; i < len; i++) {
        var index = Math.floor(Math.random() * str.length);
        result.push(str[index]);
    }
    return result.join('');
}

/**
 * 获得当前地址栏传递参数
 * @returns {null}
 */
export function getUrlString (name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    var r = decodeURIComponent(window.location.search).substr(1).match(reg);
    if (r != null) return r[2];
    return null;
}

export function searchParse (str) {
    var _search = window.location.search.substr(1);
    var _searchArr = _search.split('&');

    var _searchObj = {}
    _searchArr.map((value, index) => {
        var _valueArr = value.split('=');
        _searchObj[_valueArr[0]] = decodeURIComponent(_valueArr[1])
    });

    return _searchObj
}

export function getHashString (name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    var r = window.location.hash.substr(2).match(reg);
    if (r != null) return decodeURIComponent(r[2]);
    return null;
}

/**
 * 获得当前地址栏全部参数字符串
 * @returns {null}
 */
export function getAllUrlParams (url) {
    var url = url ? url : window.location.href;
    var params = url.indexOf("#") > -1 ? url.substring(url.indexOf("?"),url.indexOf("#")) :  url.substring(url.indexOf("?"))
    return params;
}

/*
 操作 sessionstorage
 */
export function setStorage(name, obj) {
    let str = JSON.stringify(obj)
    sessionStorage[name] = str
}
export function getStorage(name) {
    if (sessionStorage[name] && sessionStorage[name] != "undefined") {
        return JSON.parse(sessionStorage[name])
    } else {
        return false
    }
}


//浏览器信息
export function getBrowserInfo(app) {
    var ua = navigator.userAgent.toLowerCase();
    var isIos = ua.indexOf('ipad') > -1 || ua.indexOf('iphone') > -1 || false;
    var inWx = ua.indexOf('micromessenger') > -1 || false;
    var inJdApp = ua.indexOf('jdapp') > -1 || false;
    var inJrApp = ua.indexOf('jdjr') > -1 || ua.indexOf('android-async-http') > -1 || false;
    var inWyApp = ua.indexOf('WalletClient') > -1 || false;
    var inApp = (getUrlString('source') == "app" ? true : false);
    var resultObj = {
        isIos: isIos,
        inWx: inWx,
        inApp: inApp,
        inJdApp: inJdApp,
        inJrApp: inJrApp,
        inWyApp: inWyApp
    }
    return resultObj[app]
}

//获取当前渠道
export function getChannelApp() {
    var channel = ""
    if(getBrowserInfo('inJrApp')) {
        channel = '3'
    }else if(getBrowserInfo('inJdApp')) {
        channel = "2"
    }else {
        channel = '1'
    }

    return channel;
}



// WEBPACK FOOTER //
// ./src/assets/js/utils.js